import { Search } from "@mui/icons-material"
import { Box, Container, Grid, IconButton, InputBase, Paper } from "@mui/material"
import { Helmet } from "react-helmet"
import React from "react"
import { Linechart } from "../components/Linechart"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined"
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined"
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined"
import ClientDashboardAnalytics from "../components/ClientDashboardAnalytics"
import { useEffect, useState } from "react"
import axios from "axios"
import apiClient from "../api/apiClient"
import Card from "@mui/material/Card"
import { Chart } from "react-google-charts"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js"
import { Bar } from "react-chartjs-2"
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      position: "top"
    },
    title: {
      display: false,
      text: "Chart.js Bar Chart"
    }
  },
  scales: {
    x: {
      grid: {
        offset: true,
        color: "rgba(148, 163, 184, 0.18)"
      },
      ticks: {
        color: "#68717d",
        font: { weight: 600 }
      }
    },
    y: {
      grid: {
        color: "rgba(148, 163, 184, 0.22)"
      },
      ticks: {
        color: "#68717d"
      }
    }
  }
}

const labels = [["Clients"], ["Samples"], ["Technicians"]]

// export const data = {
//   labels,
//   datasets: [
//     {
//       label: 'Dataset 1',
//       data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
//       backgroundColor: 'rgba(255, 99, 132, 0.5)',
//     },
//     {
//       label: 'Dataset 2',
//       data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
//       backgroundColor: 'rgba(53, 162, 235, 0.5)',
//     },
//   ],
// };

function Dashboard() {
  const [sample, setSample] = useState(0)
  const [tech, setTech] = useState(0)
  const [client, setClient] = useState(0)

  const fetchData = async () => {
    try {
      const [apiSample, apiTech, apicl] = await Promise.all([
        apiClient.get("/sample/"),
        apiClient.get("/auth/all-users-t"),
        apiClient.get("/client/")
      ])

      if (apiSample.ok && apiTech.ok && apicl.ok) {
        const sample = apiSample.data.count
        //console.log(sample, "sample");
        const tech = apiTech.data.count
        //console.log(tech, "tn");
        const client = apicl.data.count

        //console.log(client, "client");
        // Update the state with the retrieved data
        setSample(sample)
        setTech(tech)
        setClient(client)
      }
    } catch (error) {
      //console.log(error);
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  // const data = [['Technician', 'Value'], ...technicianNames.map((name) => [name, 0])];
  // const data = [['Day', 'Technicians'], ...Array.from({ length: 31 }, (_, i) => [i + 1, tech])];
  // const data = [
  //   ["Day", "Technicians"],
  //   [1, 1],
  //   [2, 5],
  //   [3, 12],
  //   [4, 43],
  //   [5, 2],
  //   [6, 4],
  //   [7, 0],
  //   [8, 0],
  //   [9, 0],
  //   [10, 0],
  //   [11, 0],
  //   [12, 0],
  //   [13, 0],
  //   [14, 0],
  //   [15, 0],
  //   [16, 0],
  //   [17, 10],
  //   [18, 0],
  //   [19, 0],
  //   [20, 0],
  //   [21, 0],
  //   [22, 0],
  //   [23, 0],
  //   [24, 0],
  //   [25, 0],
  //   [26, 20],
  //   [27, 0],
  //   [28, 0],
  //   [29, 0],
  //   [30, 0],
  //   [31, 0],
  // ];

  // //console.log(data);
  // const data = [
  //   ['name', ''],
  //   ['Name', 0],
  //   ['Name', 10],
  //   ['Name', 23],
  //   ['Name', 17],
  //   ['Name', 18],
  //   ['Name', 9],
  //   ['Name', 11],
  //   ['Name', 27],
  // ];

  // const options = {
  //   bars: "vertical",
  //   bar: { groupWidth: "10%" }, // Adjust the value to control the bar width
  //   colors: ["#5733FF"], // Replace with your desired colors for each bar
  //   // Other chart options (if any)
  // };

  // const data = {
  //   datasets: [
  //     {
  //       label: "Clients",
  //       data: [5], // Replace these values with your data for Section 1
  //       backgroundColor: "rgba(255, 99, 132, 0.5)",
  //     },
  //     {
  //       label: "Samples",
  //       data: [3], // Replace these values with your data for Section 2
  //       backgroundColor: "rgba(53, 162, 235, 0.5)",
  //     },
  //     {
  //       label: "Technicians",
  //       data: [2], // Replace these values with your data for Section 3
  //       backgroundColor: "rgba(75, 192, 192, 0.5)",
  //     },
  //   ],
  // };
  const data = {
    labels: ["Clients", "Samples", "Technicians"],
    datasets: [
      {
        barThickness: 50,
        maxBarThickness: 50,
        label: "Data",
        data: [client, sample, tech],
        backgroundColor: ["rgba(255, 99, 132, 0.2)", "rgba(255, 159, 64, 0.2)", "#E0ECFF"],
        borderColor: ["rgb(255, 99, 132)", "rgb(255, 159, 64)", "rgb(255, 205, 86)"],
        borderWidth: 1
      }
    ]
  }

  const stats = [
    {
      title: "Technicians Added",
      value: tech,
      icon: <BadgeOutlinedIcon />,
      color: "#3f83f8",
      backgroundColor: "#eaf2ff"
    },
    {
      title: "Samples Received",
      value: sample,
      icon: <ScienceOutlinedIcon />,
      color: "#d29b12",
      backgroundColor: "#fff6dc"
    },
    {
      title: "Clients Added",
      value: client,
      icon: <PeopleAltOutlinedIcon />,
      color: "#e83f70",
      backgroundColor: "#ffe8f0"
    }
  ]

  //console.log(data);
  //console.log(client,sample,tech,"asd");
  // const data = [
  //   ["", "Data"],
  //   ['Clients', client],
  //   ['Samples', sample],
  //   ['Technicians', tech],
  // ];
  // const data = [
  //   ['Clients', client],
  //   ['Samples', sample],
  //   ['Technicians', tech],
  // ];

  return (
    <Box sx={{ backgroundColor: "#fff", minHeight: "100vh", pb: 6 }}>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <Container maxWidth={false} sx={{ maxWidth: 1180, px: { xs: 2, md: 3 } }}>
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 700, color: "#3f4a5a", mb: 0.5 }}>
                Dashboard
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Overview of clients, samples, and technician activity.
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid
            item
            md={11}
            xs={12}
            component={Paper}
            elevation={0}
            sx={{
              p: { xs: 2, md: 4 },
              borderRadius: "18px",
              border: "1px solid #e7eaf0",
              boxShadow: "0 18px 46px rgba(15, 23, 42, 0.1)",
              backgroundColor: "#fff"
            }}
          >
            <Grid container spacing={2.5}>
              {stats.map(item => (
                <Grid key={item.title} item md={4} xs={12}>
                  <Card
                    elevation={0}
                    sx={{
                      height: "100%",
                      borderRadius: "10px",
                      border: "1px solid #edf0f4",
                      boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
                      transition: "transform 160ms ease, box-shadow 160ms ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 14px 34px rgba(15, 23, 42, 0.12)"
                      }
                    }}>
                    <CardContent sx={{ display: "flex", alignItems: "center", gap: 1.75, p: 2.5 }}>
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: item.backgroundColor,
                          color: item.color,
                          borderRadius: "10px",
                          fontSize: 30,
                          flexShrink: 0
                        }}>
                        {item.icon}
                      </Box>
                      <Box>
                        <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
                          {item.title}
                        </Typography>
                        <Typography variant="h4" sx={{ color: "#121826", fontWeight: 700, lineHeight: 1.15 }}>
                          {item.value}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <Grid
              component={Paper}
              elevation={0}
              sx={{
                mt: 3,
                p: { xs: 2, md: 3 },
                borderRadius: "10px",
                border: "1px solid #edf0f4",
                boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)"
              }}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
                  Activity Summary
                </Typography>
                <Typography variant="h5" sx={{ color: "#121826", fontWeight: 700 }}>
                  {client + sample + tech} total records
                </Typography>
              </Box>
              <Box sx={{ minHeight: 320 }}>
                <Bar options={options} data={data} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}
export default Dashboard
